import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState(
            ['activeFilters', 'jobs', 'filteredJobs', 'locationError', 'isFiltering'],
        )
    },
    methods: {
        isActiveFilter( filter ) {
            let vm = this;

            if( vm.activeFilters[filter]?.value !== null && vm.activeFilters[filter]?.value?.length > 0 ) {
                return true;
            }

            return false;
        },
        isActiveFilterOption( filter, value ) {
            let vm = this;

            if( vm.activeFilters[filter].type == 'single' || vm.activeFilters[filter].type == 'location' ) {
                if( value !== undefined && value == vm.activeFilters[filter].value ) {
                    return true;
                }
            }
            if( vm.activeFilters[filter].type == 'multiple' ) {
                if ( vm.activeFilters[filter].value.indexOf(value) !== -1 ) {
                    return true;
                }
            }

            return false;
        },
        resetFilters() {
            let vm = this,
                isFiltering = false,
                filteredJobs = null;

            filteredJobs = vm.jobs;

            Object.keys(vm.activeFilters).forEach((filter, index) => {
                if( vm.activeFilters[filter].type == 'single' || ( vm.activeFilters[filter].type == 'location' && filter != 'specific_region' ) ) {
                    vm.activeFilters[filter].value = null;
                }
                if( vm.activeFilters[filter].type == 'multiple' ) {
                    vm.activeFilters[filter].value = [];
                }
                vm.activeFilters.location.value = {
                    'search': null,
                    'lat': null,
                    'lng': null
                };
                vm.activeFilters.location_radius.value = null;
            });

            if( vm.activeFilters['specific_region'].value != null ) {
                filteredJobs = vm.filterBySpecificRegion( filteredJobs );
                isFiltering = true;
            }

            vm.$store.dispatch( 'updateIsFiltering', isFiltering );
            vm.$store.dispatch( 'updateFilteredJobs', filteredJobs );
            vm.$store.dispatch( 'updateLocationError', null );

        },
        toggleFilters( filter, value ) {
            let vm = this,
                filteredJobs = null;

            filteredJobs = vm.jobs;

            if( vm.activeFilters[filter].type == 'single' || vm.activeFilters[filter].type == 'location' ) {
                vm.toggleSingleFilter( filter, value );
            }
            if( vm.activeFilters[filter].type == 'multiple' ) {
                vm.toggleMultipleFilter( filter, value );
            }

            vm.toggleOpenFilter();
        },
        filterJobs() {
            let vm = this,
                filteredJobs = null,
                isFiltering = false;

            filteredJobs = vm.jobs;

            Object.keys(vm.activeFilters).forEach((filter, index) => {
                if( vm.activeFilters[filter].type == 'single' && vm.activeFilters[filter].value !== null ){
                    filteredJobs = vm.filterBySingle( filteredJobs, filter );
                    isFiltering = true;
                }
                if( vm.activeFilters[filter].type == 'multiple' && vm.activeFilters[filter].value.length !== 0 ){
                    filteredJobs = vm.filterByMultiple( filteredJobs, filter );
                    isFiltering = true;
                }
                if( filter == 'location_radius' && vm.activeFilters[filter].value !== null && vm.activeFilters.location.value !== null ){
                    isFiltering = true;

                    if( vm.activeFilters[filter].value != 'none' ){
                        filteredJobs = vm.filterByLocation( filteredJobs, 'radius' );
                    }
                } else if( vm.activeFilters.location.value.search !== null && filter == 'location_radius' && vm.activeFilters[filter].value == null ){
                    isFiltering = true;

                    filteredJobs = vm.filterByLocation( filteredJobs, 'address' );
                } else if( vm.activeFilters.specific_region.value != null ){
                    filteredJobs = vm.filterBySpecificRegion( filteredJobs );
                    isFiltering = true;
                }
            });

            vm.$store.dispatch( 'updateIsFiltering', isFiltering );
            vm.$store.dispatch( 'updateFilteredJobs', filteredJobs );

        },
        toggleOpenFilter() {
            let vm = this;

            vm.openFilter = !vm.openFilter;
        },
        toggleSingleFilter( filter, value ) {
            let vm = this;

            if ( value == vm.activeFilters[filter].value ) {
                vm.activeFilters[filter].value = null;
            } else {
                vm.activeFilters[filter].value = value;
            }
        },
        toggleMultipleFilter( filter, value ) {
            let vm = this;

            if ( vm.activeFilters[filter].value.indexOf(value) === -1 ) {
                vm.activeFilters[filter].value.push(value);
            } else {
                vm.activeFilters[filter].value = vm.activeFilters[filter].value.filter(item => item !== value);
            }
        },
        filterBySingle( jobs, filter ) {
            let vm = this;

            let filteredJobs = jobs?.filter(function(item){
                if( item[filter] !== null && item[filter] == vm.activeFilters[filter].value ) {
                    return item;
                }
            });

            return filteredJobs;
        },
        filterByMultiple( jobs, filter ) {
            let vm = this;

            let filteredJobs = jobs?.filter(function(item){
                // When no filter entry for the job exists.
                if (item[filter] == null){
                    return false;
                }
                // When the filter entry for the job is an array
                if (Array.isArray(item[filter])){
                    return vm.activeFilters[filter].value.some(r => item[filter].indexOf(r) >= 0);
                }
                // Non array and non-null filter entries
                return vm.activeFilters[filter].value.includes(item[filter]);
            });

            return filteredJobs;
        },
        filterByLocation( jobs, type ) {
            let vm = this,
                filteredJobs = jobs,
                searchString = '';

            if( type == 'radius' ) {
                filteredJobs = jobs?.filter(function(item){
                    if( item.address?.lat ){
                        if( vm.calculateDistance( item.address.lat, item.address.lng, vm.activeFilters.location.value.lat, vm.activeFilters.location.value.lng ) <= vm.activeFilters.location_radius.value ) {
                            return item;
                        }
                    }
                });
            } else if( type == 'address' ) {

                if( vm.activeFilters.location.value.search !== undefined ) {
                    searchString = vm.activeFilters.location.value.search.trim().toLowerCase();
                }

                filteredJobs = jobs?.filter(function(item){
                    if( item.location !== undefined && item.location.toLowerCase().indexOf(searchString) !== -1 ) {
                        return item;
                    }
                });
            }

            return filteredJobs;
        },
        filterBySpecificRegion( jobs ) {
            let vm = this,
                filteredJobs = jobs;

            filteredJobs = jobs?.filter(function(item){
                if( item.address !== undefined && item.address.post_code !== null && vm.activeFilters.specific_region.value.includes( item.address.post_code.split(' ')[0] ) ) {
                    return item;
                }
            });

            return filteredJobs;
        },

        /* RY Added code to filter by practice name */
        filterByPracticeName(jobs) {
            let vm = this;
            let filteredJobs = jobs;
        
            // Check if there's a value in the practiceName filter
            if (vm.activeFilters.practiceName.value) {
                // Perform case-insensitive matching
                let searchTerm = vm.activeFilters.practiceName.value.toLowerCase();
                filteredJobs = filteredJobs.filter(job => {
                    // Make sure the job object has the practice_name property
                    if (job.practice_name && typeof job.practice_name === 'string') {
                        // Check if the practice_name contains the search term
                        return job.practice_name.toLowerCase().includes(searchTerm);
                    }
                    return false; // If the practice_name is missing or not a string, exclude the job
                });
            }
        
            console.log("Filtered Jobs:", filteredJobs);

            return filteredJobs;
        },

        calculateDistance( lat1, lon1, lat2, lon2 ) {
            if ( (lat1 == lat2) && (lon1 == lon2) ) {
                return 0;
            }
            else {
                var radlat1 = Math.PI * lat1/180;
                var radlat2 = Math.PI * lat2/180;
                var theta = lon1-lon2;
                var radtheta = Math.PI * theta/180;
                var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                if (dist > 1) {
                    dist = 1;
                }
                dist = Math.acos(dist);
                dist = dist * 180/Math.PI;
                dist = dist * 60 * 1.1515;
                return dist;
            }
        }
    },
    data() {
        return {
        }
    }
}